
export class ArchiSmallERRORS {
    public static readonly VALIDATION_HASH_ALREADY_EXISTS: number = 11;
    public static readonly FATTURA_ELETTRONICA_ATTIVA_ALREADY_EXISTS: number = 12;
    public static readonly INVALID_CURRENT_PASSWORD: number = 16;
    public static readonly ARCHIDRIVE_CANNOT_DELETE_SYSTEM_FOLDER: number = 19;
    public static readonly INVALID_PIVA: number = 20;
    public static readonly BLACKLISTED_PIVA: number = 21;
    public static readonly INVALID_XML: number = 22;
    public static readonly ANAGRAFICA_EMAIL_ALREADY_USED: number = 25;
    public static readonly ANAGRAFICA_DUPLICATE_EMAILS: number = 26;
    public static readonly METADATA_MISSING: number = 34;
    public static readonly DUPLICATE_KEY: number = 46;
    public static readonly REMOTE_SIGNATURE_OTP_INCORRECT: number = 48;
    public static readonly QUOTA_FULL: number = 51;
    public static readonly INVALID_ACCESS_TOKEN: number = 53;
    public static readonly INVALID_FISCALCODE: number = 58;
    public static readonly DUPLICATE_API_CLIENT_ID: number = 59;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/errors.ts